import Image from './image';

export default {
  tag: 'img',
  format: `![alt](url)`,
  sourcePipeline: (source: string) => source,
  componentFn: (node: any) => {
    return node.src ? <Image src={node.src} /> : null;
  }
};
